/* eslint-disable @atlassian/relay/unused-fields */
import { graphql } from 'react-relay';

export const SEARCH_COMPASS_COMPONENTS_QUERY_AGG_RELAY = graphql`
	query gqlJiraJswComponentsTableComponentsQuery(
		$cloudId: String!
		$query: CompassSearchComponentQuery
		$includeState: Boolean!
	) {
		compass {
			searchComponents(cloudId: $cloudId, query: $query) {
				__typename
				... on CompassSearchComponentConnection {
					nodes {
						__typename
						link
						component {
							__typename
							id
							name
							description
							typeId
							ownerId
							state @include(if: $includeState)
							links {
								id
								name
								url
								type
							}
							scorecardScores {
								totalScore
								maxTotalScore
							}
							inwardRelationships: relationships(
								query: { first: 5, direction: INWARD, filters: { types: [DEPENDS_ON] } }
							) {
								__typename
								... on CompassRelationshipConnection {
									nodes {
										startNode {
											id
											name
											typeId
											ownerId
										}
									}
									pageInfo {
										hasNextPage
									}
								}
								... on QueryError {
									message
									extensions {
										__typename
										statusCode
										errorType
									}
								}
							}
							outwardRelationships: relationships(
								query: { first: 5, direction: OUTWARD, filters: { types: [DEPENDS_ON] } }
							) {
								__typename
								... on CompassRelationshipConnection {
									nodes {
										endNode {
											id
											name
											typeId
											ownerId
										}
									}
									pageInfo {
										hasNextPage
									}
								}
								... on QueryError {
									message
									extensions {
										__typename
										statusCode
										errorType
									}
								}
							}
						}
					}
				}
				... on QueryError {
					message
					extensions {
						__typename
						statusCode
						errorType
					}
				}
			}
		}
	}
`;
